export function setVouchersTypes(state, vouchertype) {
    state.voucherTypes = vouchertype
}
export function setBranchOffice(state , branchOffice) {
    state.paramsVoucherType.branchoffice = branchOffice
}
export function setBranchOffices(state , branchOffices) {
    state.branchOffices = branchOffices
}
export function setTemplates(state , templates) {
    state.templates = templates
}
export function setTemplatesExclude(state , templates) {
    state.templates_exlude = templates
}
export function setLines(state, lines){
    state.lines = lines
}
export function setGroups(state, sublines){
    state.sublines = sublines
}
export function setBrands(state, brands){
    state.brands = brands
}
export function setSubbrands(state, subbrands){
    state.subbrands = subbrands
}
export function setProducts(state, products){
    state.products = products
}
export function setContacts(state, contacts){
    state.contacts = contacts
}
export function setDepartaments(state, departaments) {
    state.departaments = departaments
}
export function setCities(state, cities) {
    state.cities = cities
}
export function setSellers(state, sellers) {
    state.sellers = sellers
}
export function settypes_operations(state,types_operations){
    state.types_operations = types_operations
}
export function setBranchofficeWarehousesEntry(state, branchofficeWarehouses){
    state.branchofficeWarehouses = branchofficeWarehouses
}
export function setLoading(state, loading){
    state.loading = loading
}

export function setReportData(state,data){
    state.report_data = data
}

/*
    Limpiar todos los filtros que tiene y los datos del reporte.
 */
export function clearParams (state) {
    state.report_data = [];
    Object.assign(state.params, {
        date : null,
        voucherType : null,
        branchOffice : null,
        template : null,
        filter_lines: [],
        filter_sublines : [],
        filter_brands : [],
        filter_subbrands: [],
        product:[],
        contact : [],
        departament : [],
        city:[],
        seller:[],
        name_file:null,
        detailed_by_product:1,
        type_operations:[],
        f_exclude_lines:null,
        f_exclude_template:null,
        branchoffice_warehouse: null,
        include_prod_excludes:0,
        is_combo:0,

    })
}



// WEBPACK FOOTER //
// ./src/modules/operations-report/mutations.js